import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

export const usePendingModulePaymentVerifications = (clientId, enabled) =>
  useQuery({
    queryKey: ["pending-module-payment-verifications", clientId],
    queryFn: () =>
      axios
        .get(`${API_URL}/module-payments/pending`, { params: { clientId } })
        .then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && !!clientId,
    refetchOnWindowFocus: false,
  });

export const useAllPendingModulePaymentVerifications = (enabled) =>
  useQuery({
    queryKey: ["pending-module-payment-verifications-all"],
    queryFn: () => axios.get(`${API_URL}/module-payments/pending`).then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled),
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
  });

export const useModulePaymentNotes = (clientAccountDetailId, enabled) =>
  useQuery({
    queryKey: ["module-payment-notes", clientAccountDetailId],
    queryFn: () =>
      axios
        .get(`${API_URL}/notes`, {
          params: { parentId: clientAccountDetailId, parentType: "ACCOUNT_DETAIL" },
        })
        .then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && clientAccountDetailId != null,
    refetchOnWindowFocus: false,
  });

/**
 * expectedRevision is the revision the verifier was shown. When the sender has edited the payment
 * since, the server answers 409 with the current version instead of deciding on stale figures.
 */
export const verifyModulePayment = (paymentId, expectedRevision) =>
  axios.post(`${API_URL}/module-payments/${paymentId}/verify`, null, {
    params: expectedRevision != null ? { expectedRevision } : undefined,
  });

export const rejectModulePayment = (paymentId, feedback, expectedRevision) =>
  axios.post(
    `${API_URL}/module-payments/${paymentId}/reject`,
    { feedback },
    { params: expectedRevision != null ? { expectedRevision } : undefined }
  );

/** The sender corrects a payment still waiting for verification. payload carries expectedRevision. */
export const editPendingModulePayment = (paymentId, payload) =>
  axios.put(`${API_URL}/module-payments/${paymentId}/pending`, payload);

/** The sender takes back a payment still waiting for verification. */
export const withdrawModulePayment = (paymentId, { expectedRevision, reason }) =>
  axios.post(`${API_URL}/module-payments/${paymentId}/withdraw`, { expectedRevision, reason });

export const modifyModulePayment = (paymentId, payload) =>
  axios.post(`${API_URL}/module-payments/${paymentId}/modify`, payload);

export const refundModulePayment = (paymentId, payload) =>
  axios.post(`${API_URL}/module-payments/${paymentId}/refund`, payload);

export const deleteModulePayment = (paymentId, reason) =>
  axios.delete(`${API_URL}/module-payments/${paymentId}`, { params: { reason } });
